import { Component, Input, OnInit } from '@angular/core';

import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-growing-share-and-driving-refresh-in-consumer',
  templateUrl: './growing-share-and-driving-refresh-in-consumer.component.html',
  styleUrls: ['./growing-share-and-driving-refresh-in-consumer.component.scss']
})
export class GrowingShareAndDrivingRefreshInConsumerComponent implements OnInit {
  @Input() data: any;
  // ../assets/empower/pitch-factory/images/8-screen-01.png
  imageUrl = NO_IMAGE;

  innerHtml = '';
  constructor(public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService) { }

  ngOnInit(): void {
    if (this.data) {
      this.data = JSON.parse(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const imageUrl = this.empowerModernLifeService.getPageImgState(pageId);
    if (imageUrl) {
      this.imageUrl = imageUrl;
    }
    if (this.imageUrl == NO_IMAGE) this.emitExportEvent(null);

    this.innerHtml = generateTitleDiv(this.data);
  }

  imageChange(imageUrl) {
    this.empowerModernLifeService.setPageImgState(this.data.pageId, imageUrl);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(8, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

}
